@if (advices().length > 0) {
  <section>
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-lg-12 list-wrapper">
          <ul #listElement class="list">
            @for (advice of advices(); track advice) {
              <li class="list-item">
                @if (advice.rate; as rate) {
                  <app-rate [mean]="rate" [size]="'2rem'" [theme]="'WHITE'" class="rate" />
                }
                @if (advice.quote; as quote) {
                  <app-quote [maxLength]="315" [quote]="quote" class="quote" />
                }
              </li>
            }
          </ul>
          @if (advices().length > 1) {
            <div class="list-actions">
              <i
                (click)="onPrev(advices().length)"
                [color]="'WHITE'"
                [iconName]="'ARROW_BIG_LEFT'"
                [size]="breakpoints() === 'mobile' ? '2rem' : '3.2rem'"
                class="list-actions-left"></i>
              <i
                (click)="onNext(advices().length)"
                [color]="'WHITE'"
                [iconName]="'ARROW_BIG_RIGHT'"
                [size]="breakpoints() === 'mobile' ? '2rem' : '3.2rem'"
                class="list-actions-right"></i>
            </div>
          }
        </div>
        @if (data().text; as text) {
          <p class="col-xs-12 col-lg-12 paragraph">{{ text }}</p>
        }
      </div>
    </div>
  </section>
}
